
// import React, { useState, useEffect } from "react";
// import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

// // Components
// import Navbar from "./components/Navbar";
// import Dashboard from "./components/Dashboard";
// import Register from "./components/Register";
// import Login from "./components/Login";
// import Profile from "./components/Profile";
// import Appointments from "./components/Appointments";
// import MedicalRecords from "./components/MedicalRecords";
// import Prescriptions from "./components/Prescriptions";
// import Notifications from "./components/Notifications";
// import PatientProfile from "./components/PatientProfile";
// import PatientManagement from "./components/PatientManagement";
// import EmergencyDashboard from "./components/emergency/EmergencyDashboard";

// // Pages
// import TelemedicineList from "./pages/TelemedicineList";
// import Telemedicine from "./pages/Telemedicine";
// import Doctors from "./pages/Doctors";
// import DoctorProfile from "./pages/DoctorProfile";
// import Favorites from "./pages/Favorites";
// import Caregivers from "./pages/Caregivers";
// import BookAppointment from "./pages/BookAppointment";

// // Context Providers
// import { ToastProvider, useToast } from "./context/ToastContext";
// import { FavoritesProvider } from "./context/FavoritesContext";
// import { ActivityProvider } from "./context/ActivityContext";
// import { MedicalRecordsProvider } from "./context/MedicalRecordsContext";
// import { SearchProvider } from "./context/SearchContext";
// import { PrescriptionsProvider } from "./context/PrescriptionsContext";
// import { PatientProfileProvider } from "./context/PatientProfileContext";
// import { DashboardProvider } from "./context/DashboardContext";
// import { EnhancedNotificationsProvider } from "./context/EnhancedNotificationsContext";
// import { EmergencyProvider } from "./context/EmergencyContext";
// import { CaregiverProvider } from "./context/CaregiverContext";

// // Hooks
// import useAutoLogout from "./hooks/useAutoLogout";

// // ------------------------------------------------------------
// // MAIN APP
// // ------------------------------------------------------------
// function App() {
//   const [user, setUser] = useState(() => {
//     const stored = localStorage.getItem("user");
//     return stored ? JSON.parse(stored) : null;
//   });

//   const [darkMode, setDarkMode] = useState(
//     () => localStorage.getItem("darkMode") === "true"
//   );

//   const { addToast } = useToast();
//   const navigate = useNavigate();

//   // Sync user across tabs
//   useEffect(() => {
//     const handleStorage = () => {
//       const updated = localStorage.getItem("user");
//       setUser(updated ? JSON.parse(updated) : null);
//     };
//     window.addEventListener("storage", handleStorage);
//     return () => window.removeEventListener("storage", handleStorage);
//   }, []);

//   // Dark mode
//   useEffect(() => {
//     document.documentElement.classList.toggle("dark", darkMode);
//     localStorage.setItem("darkMode", darkMode);
//   }, [darkMode]);

//   // Login
//   const handleLogin = (loggedInUser) => {
//     localStorage.setItem("user", JSON.stringify(loggedInUser));
//     setUser(loggedInUser);
//     addToast("Login successful!", "success");
//     navigate("/dashboard");
//   };

//   // Logout
//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     addToast("Logged out successfully", "info");
//     navigate("/login");
//   };

//   // Auto logout
//   useAutoLogout(user, handleLogout);

//   return (
//     <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-black dark:text-white transition">
//       {user && (
//         <Navbar
//           user={user}
//           onLogout={handleLogout}
//           darkMode={darkMode}
//           setDarkMode={setDarkMode}
//         />
//       )}

//       <div className={user ? "pt-20 px-4" : "px-4"}>
//         <Routes>
//           {/* Default */}
//           <Route
//             path="/"
//             element={user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
//           />

//           {/* Auth */}
//           <Route
//             path="/login"
//             element={user ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />}
//           />

//           <Route
//             path="/register"
//             element={
//               user ? (
//                 <Navigate to="/dashboard" />
//               ) : (
//                 <Register onSuccess={() => navigate("/login")} />
//               )
//             }
//           />

//           {/* Protected */}
//           <Route
//             path="/dashboard"
//             element={user ? <Dashboard user={user} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/profile"
//             element={user ? <Profile user={user} setUser={setUser} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/patient-profile"
//             element={user ? <PatientProfile /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/appointments"
//             element={user ? <Appointments user={user} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/medical-records"
//             element={user ? <MedicalRecords user={user} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/prescriptions"
//             element={user ? <Prescriptions user={user} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/notifications"
//             element={user ? <Notifications user={user} /> : <Navigate to="/login" />}
//           />

//           {/* Telemedicine */}
//           <Route
//             path="/telemedicine"
//             element={user ? <TelemedicineList user={user} /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/telemedicine/:appointmentId"
//             element={user ? <Telemedicine user={user} /> : <Navigate to="/login" />}
//           />

//           {/* Doctors */}
//           <Route
//             path="/doctors"
//             element={user ? <Doctors /> : <Navigate to="/login" />}
//           />

//           <Route
//             path="/doctors/:id"
//             element={user ? <DoctorProfile /> : <Navigate to="/login" />}
//           />

//           {/* Favorites */}
//           <Route
//             path="/favorites"
//             element={user ? <Favorites /> : <Navigate to="/login" />}
//           />

//           {/* Emergency */}
//           <Route
//             path="/emergency"
//             element={user ? <EmergencyDashboard user={user} /> : <Navigate to="/login" />}
//           />

//           {/* Patients */}
//           <Route
//             path="/patients"
//             element={user ? <PatientManagement /> : <Navigate to="/login" />}
//           />

//           {/* Caregivers */}
//           <Route
//             path="/caregivers"
//             element={user ? <Caregivers /> : <Navigate to="/login" />}
//           />

//           {/* Fallback */}
//           <Route
//             path="*"
//             element={<Navigate to={user ? "/dashboard" : "/login"} />}
//           />
//           <Route
//   path="/appointments/book/:doctorId"
//   element={user ? <BookAppointment /> : <Navigate to="/login" />}
// />

//         </Routes>
//       </div>
//     </div>
//   );
// }

// // ------------------------------------------------------------
// // PROVIDER WRAPPER
// // ------------------------------------------------------------
// export default function AppWrapper() {
//   return (
//     <ToastProvider>
//       <FavoritesProvider>
//         <ActivityProvider>
//           <EnhancedNotificationsProvider>
//             <PrescriptionsProvider>
//               <MedicalRecordsProvider>
//                 <DashboardProvider>
//                   <SearchProvider>
//                     <PatientProfileProvider>
//                       <EmergencyProvider>
//                         <CaregiverProvider>
//                           <App />
//                         </CaregiverProvider>
//                       </EmergencyProvider>
//                     </PatientProfileProvider>
//                   </SearchProvider>
//                 </DashboardProvider>
//               </MedicalRecordsProvider>
//             </PrescriptionsProvider>
//           </EnhancedNotificationsProvider>
//         </ActivityProvider>
//       </FavoritesProvider>
//     </ToastProvider>
//   );
// }

import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

/* ===================== COMPONENTS ===================== */
import AppLayout from "./components/AppLayout";
import Dashboard from "./components/Dashboard";
import Register from "./components/Register";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Appointments from "./components/Appointments";
import MedicalRecords from "./components/MedicalRecords";
import Prescriptions from "./components/Prescriptions";
import Notifications from "./components/Notifications";
import PatientProfile from "./components/PatientProfile";
import PatientManagement from "./components/PatientManagement";
import EmergencyDashboard from "./components/emergency/EmergencyDashboard";

/* ===================== PAGES ===================== */
import TelemedicineList from "./pages/TelemedicineList";
import Telemedicine from "./pages/Telemedicine";
import Doctors from "./pages/Doctors";
import DoctorProfile from "./pages/DoctorProfile";
import Favorites from "./pages/Favorites";
import Caregivers from "./pages/Caregivers";
import BookAppointment from "./pages/BookAppointment";

/* ===================== ADMIN ===================== */
import AdminRoute from "./components/AdminRoute";
import StaffRoute from "./components/StaffRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminDoctors from "./admin/AdminDoctors";
import AdminAppointments from "./admin/AdminAppointments";

/* ===================== CONTEXT ===================== */
import { ToastProvider, useToast } from "./context/ToastContext";
import { ThemeProvider } from "./context/ThemeContext";
import { THEME_STORAGE_KEY } from "./lib/theme";
import { FavoritesProvider } from "./context/FavoritesContext";
import { ActivityProvider } from "./context/ActivityContext";
import { MedicalRecordsProvider } from "./context/MedicalRecordsContext";
import { SearchProvider } from "./context/SearchContext";
import { PrescriptionsProvider } from "./context/PrescriptionsContext";
import { PatientProfileProvider } from "./context/PatientProfileContext";
import { DashboardProvider } from "./context/DashboardContext";
import { EnhancedNotificationsProvider } from "./context/EnhancedNotificationsContext";
import { EmergencyProvider } from "./context/EmergencyContext";
import { CaregiverProvider } from "./context/CaregiverContext";

/* ===================== HOOKS ===================== */
import useAutoLogout from "./hooks/useAutoLogout";

/* ===================================================== */
/* ======================= APP ========================= */
/* ===================================================== */

function App() {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const { addToast } = useToast();
  const navigate = useNavigate();

  /* Sync user across tabs */
  useEffect(() => {
    const handleStorage = () => {
      const updated = localStorage.getItem("user");
      setUser(updated ? JSON.parse(updated) : null);
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  /* Login */
  const handleLogin = (loggedInUser) => {
    localStorage.setItem("user", JSON.stringify(loggedInUser));
    setUser(loggedInUser);
    addToast("Login successful!", "success");
    navigate("/dashboard");
  };

  /* Logout */
  const handleLogout = () => {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    setUser(null);
    localStorage.clear();
    if (savedTheme) localStorage.setItem(THEME_STORAGE_KEY, savedTheme);
    addToast("Logged out successfully", "info");
    navigate("/login");
  };

  useAutoLogout(user, handleLogout);

  return (
    <div className="min-h-screen app-shell transition-colors duration-theme">
      <Routes>
        {/* Default */}
        <Route
          path="/"
          element={<Navigate to={user ? "/dashboard" : "/login"} />}
        />

        {/* Auth */}
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/dashboard" /> : <Register />}
        />

        {/* Authenticated app shell with sidebar */}
        <Route
          element={
            user ? (
              <AppLayout user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route path="/dashboard" element={<Dashboard user={user} />} />
          <Route path="/profile" element={<Profile user={user} setUser={setUser} />} />
          <Route path="/patient-profile" element={<PatientProfile />} />
          <Route path="/appointments" element={<Appointments user={user} />} />
          <Route path="/appointments/book/:doctorId" element={<BookAppointment />} />
          <Route path="/medical-records" element={<MedicalRecords user={user} />} />
          <Route path="/prescriptions" element={<Prescriptions user={user} />} />
          <Route path="/notifications" element={<Notifications user={user} />} />
          <Route path="/telemedicine" element={<TelemedicineList user={user} />} />
          <Route path="/telemedicine/:appointmentId" element={<Telemedicine user={user} />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/doctors/:id" element={<DoctorProfile />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/caregivers" element={<Caregivers />} />
          <Route path="/patients" element={<StaffRoute user={user}><PatientManagement /></StaffRoute>} />
          <Route path="/emergency" element={<EmergencyDashboard />} />
        </Route>

        {/* ================= ADMIN ROUTES ================= */}
        <Route
          path="/admin"
          element={
            <AdminRoute user={user}>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="doctors" element={<AdminDoctors />} />
          <Route path="appointments" element={<AdminAppointments />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
      </Routes>
    </div>
  );
}

/* ===================== PROVIDERS ===================== */

export default function AppWrapper() {
  return (
    <ThemeProvider>
    <ToastProvider>
      <FavoritesProvider>
        <ActivityProvider>
          <EnhancedNotificationsProvider>
            <PrescriptionsProvider>
              <MedicalRecordsProvider>
                <DashboardProvider>
                  <SearchProvider>
                    <PatientProfileProvider>
                      <EmergencyProvider>
                        <CaregiverProvider>
                          <App />
                          <Analytics />
                        </CaregiverProvider>
                      </EmergencyProvider>
                    </PatientProfileProvider>
                  </SearchProvider>
                </DashboardProvider>
              </MedicalRecordsProvider>
            </PrescriptionsProvider>
          </EnhancedNotificationsProvider>
        </ActivityProvider>
      </FavoritesProvider>
    </ToastProvider>
    </ThemeProvider>
  );
}
